import { createReducer, MetaReducer, on } from '@ngrx/store';
import LocationContextActions from './location-context.action-types';

export const locationContextFeatureKey = 'locationContext';

export interface LocationContextState {
    terminals: string[];
    centerlineGroups: string[];
    centerlines: string[];
}

export const initialLocationContextState: LocationContextState = {
    terminals: [],
    centerlineGroups: [],
    centerlines: []
};

export const metaReducers: MetaReducer<LocationContextState>[] = [];

export const terminalsReducer = createReducer(
    initialLocationContextState,

    // Terminals
    on(LocationContextActions.loadTerminals, (state, action) => {
        return {
            terminals: action.terminals,
            centerlineGroups: state.centerlineGroups,
            centerlines: state.centerlines
        };
    }),

    // Centerline Groups
    on(LocationContextActions.loadCenterlineGroups, (state, action) => {
        return {
            terminals: state.terminals,
            centerlineGroups: action.centerlineGroups,
            centerlines: state.centerlines
        };
    }),

    // Centerlines
    on(LocationContextActions.loadCenterlines, (state, action) => {
        return {
            terminals: state.terminals,
            centerlineGroups: state.centerlineGroups,
            centerlines: action.centerlines
        };
    }),

    // Reset
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    on(LocationContextActions.resetLocationContextData, (state, action) => {
        return {
            terminals: [],
            centerlineGroups: [],
            centerlines: []
        };
    })
);
